import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from '../components/Reveal';
import SectionHeading from '../components/SectionHeading';

const { FiHeart, FiSun, FiAnchor } = FiIcons;
const values = [
  { icon: FiHeart, title: 'Ausgelassen & Niveauvoll', text: 'Wir feiern wild, aber mit Stil und Qualität.' },
  { icon: FiSun, title: 'Bunt & Weltoffen', text: 'Ein fröhliches, friedliches Miteinander in Retro-Ästhetik.' },
  { icon: FiAnchor, title: 'Hanseatisch & Verbunden', text: 'Die Liebe zu Hamburg (Wellen) und zur Musik (Herzschlag).' }
];

function IdentitySection() {
  return (
    <section className="section identity-section" id="identitaet">
      <div className="section-inner">
        <SectionHeading eyebrow="01 — Wofür wir stehen">Unsere Identität: Modern Retro &amp; Upscale Fun</SectionHeading>
        <div className="identity-grid">
          <Reveal className="identity-copy">
            <article className="statement-card">
              <span className="card-label">Unsere Vision</span>
              <p>Wir etablieren Hamburg als die Hauptstadt des modernen Schlager-Entertainments. Wir schaffen ein Festival, das die Lebensfreude und Buntheit der 70er-Jahre ins Heute holt – in einem hochwertigen, sicheren und stilvollen Rahmen.</p>
            </article>
            <article className="statement-card statement-card-soft">
              <span className="card-label">Unsere Mission</span>
              <p>Wir befreien den Schlager vom Trash-Image. Mit &quot;Herzschlag Hamburg&quot; bieten wir ein Boutique-Festival-Erlebnis mit erstklassiger Musik, kreativem Design und hochwertiger Gastronomie. Wir sind der qualitative Gegenentwurf zur Ballermann-Party.</p>
            </article>
          </Reveal>
          <div className="values-list">
            {values.map(({ icon, title, text }, index) => (
              <Reveal className="value-item" delay={index * 0.08} key={title}>
                <span className="value-icon"><SafeIcon icon={icon} /></span>
                <div><h3>{title}</h3><p>{text}</p></div>
                <span className="value-number">0{index + 1}</span>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="identity-stamp" aria-hidden="true">HH<br /><span>♡</span><br />2027</div>
      </div>
    </section>
  );
}

export default IdentitySection;